import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "@/services/axios_custom";
import API_ENDPOINTS from "@/util/api";

// fetch all criteria rules for a group
export const fetchSecurityRulesCriteria = createAsyncThunk(
  "securityRulesCriteria/fetchAll",
  async () => {
    const { data } = await api.get(
      `${API_ENDPOINTS.security.securityRulesCriteria.getAll}`
    );
    return data;
  }
);

// fetch one by ID
export const fetchSecurityRuleCriteriaById = createAsyncThunk(
  "securityRulesCriteria/fetchById",
  async (id) => {
    const { data } = await api.get(
      API_ENDPOINTS.security.securityRulesCriteria.getById + id
    );
    return data;
  }
);

// create
export const createSecurityRuleCriteria = createAsyncThunk(
  "securityRulesCriteria/create",
  async (payload) => {
    const { data } = await api.post(
      API_ENDPOINTS.security.securityRulesCriteria.create,
      payload
    );
    return data;
  }
);

// update
export const updateSecurityRuleCriteria = createAsyncThunk(
  "securityRulesCriteria/update",
  async (payload) => {
    const { data } = await api.post(
      API_ENDPOINTS.security.securityRulesCriteria.update,
      payload
    );
    return data;
  }
);

// delete
export const deleteSecurityRuleCriteria = createAsyncThunk(
  "securityRulesCriteria/delete",
  async (id) => {
    await api.delete(
      API_ENDPOINTS.security.securityRulesCriteria.delete + id
    );
    return id;
  }
);
